import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import union from "lodash/union";

import { hydrate } from "@/lib";
import { fetchActivities } from "./thunk";

export interface ActivitiesState {
  error: string | null;
  status: "idle" | "fetching" | "saving";
  activities: Array<any>;
  meta: { count: number };
  page: number;
}

const initialState: ActivitiesState = {
  error: null,
  status: "idle",
  activities: [],
  meta: { count: null },
  page: 1
};

export const activitiesSlice = createSlice({
  name: "activities",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(hydrate, (state, action: PayloadAction<string>) => {
        return {
          ...state,
          ...action.payload[activitiesSlice.name]
        };
      })
      .addCase(fetchActivities.pending, (state) => {
        state.status = "fetching";
      })
      .addCase(fetchActivities.fulfilled, (state, action) => {
        const { meta, activities } = action.payload;

        state.status = "idle";
        state.meta = meta;
        state.activities = union(state.activities, activities);
        state.page = activities.length ? state.page + 1 : state.page;
      })
      .addCase(fetchActivities.rejected, (state, action) => {
        state.status = "idle";
        state.error = action.error.message;
      });
  }
});
